import React, { FC } from 'react';
import classNames from 'classnames';
import { ASSETS_PATH } from '@app/react/const/variables';

interface FooterNavigationBarProps {
    isAddCart: boolean;
    isCustomView: boolean;
    is3dView: boolean;
    isMobile: boolean;
    onAddCart: () => void;
    onPreview3d: () => void;
    onHomeClick: () => void;
}

export const FooterNavigationBar: FC<FooterNavigationBarProps> = (props) => {
    const {
        isAddCart,
        isCustomView,
        is3dView,
        isMobile,
        onAddCart,
        onPreview3d,
        onHomeClick,
    } = props;

    const rootClassName = classNames('parts-container__div');
    const cartClassName = classNames('parts-container__button--cart', {
        move: isCustomView,
        view: isAddCart,
    });

    const homeClassName = classNames('parts-container__button--home', {
        'move-none': isCustomView,
    });

    const btn3dClassName = classNames('parts-container__button--3d', {
        'current-3d-view': is3dView,
    });

    const addCartSrc = isAddCart
        ? `${ASSETS_PATH}/img/order/mobileAddCartButton.svg`
        : `${ASSETS_PATH}/img/order/mobileAddCartButtonDisable.svg`;

    const button3dSrc = is3dView
        ? `${ASSETS_PATH}/img/order/mobile3dButton.svg`
        : `${ASSETS_PATH}/img/order/mobile3dButtonDisable.svg`;

    return (
        <div className={rootClassName}>
            <button type="button" className={cartClassName} onClick={onAddCart}>
                <img src={addCartSrc} alt="cart" />
            </button>

            {isMobile && (
                <button type="button" className={btn3dClassName} onClick={onPreview3d}>
                    <img src={button3dSrc} alt="3d preview" />
                </button>
            )}

            <button type="button" className={homeClassName} onClick={onHomeClick}>
                <img src={`${ASSETS_PATH}/img/order/mobileHOME.svg`} alt="home" />
            </button>
        </div>
    );
};
